module.exports = __webpack_public_path__ + "img/NBA_FreeThrow1.60db9b68.png";